import { testimonials } from "@/mocks/homeContent";

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-2 lg:gap-16">
        <div>
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-700">
            <span className="h-px w-6 bg-primary-600"></span> 关于我们
          </span>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            让信息流动得
            <br className="hidden md:block" />
            更真实、更负责
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-600">
            曝光导航是一个聚焦公开信息聚合与素材征集的导航平台。我们相信，大量有价值的公共线索需要一个统一的入口、清晰的规则与值得托付的核验流程。
          </p>
          <p className="mt-3 text-base leading-relaxed text-foreground-600">
            我们不做情绪化的传播，只搭建一条合规、审慎、可追溯的信息通路——让掌握一手事实的内容提供者，能以安全的姿态把素材交给真正会认真处理的人。
          </p>

          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3">
            {[
              { icon: "ri-eye-close-line", t: "隐私为先", d: "最小必要原则" },
              { icon: "ri-scales-2-fill", t: "合规底线", d: "事实与法律双重把关" },
              { icon: "ri-list-check-3", t: "全程可溯", d: "受理回执可查询" },
            ].map((v) => (
              <div
                key={v.t}
                className="rounded-lg border border-background-200 bg-background-100/50 p-4 text-center"
              >
                <i className={`${v.icon} mx-auto text-2xl text-primary-600`}></i>
                <p className="mt-2 font-display text-sm font-bold text-foreground-950">{v.t}</p>
                <p className="mt-0.5 text-xs text-foreground-600">{v.d}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col justify-center">
          <h3 className="font-display text-xl font-bold text-foreground-950">来自提供方与作者的声音</h3>
          <div className="mt-6 space-y-4">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-lg border border-background-200 bg-background-100/60 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-primary-300"></i>
                <blockquote className="mt-2 text-sm leading-relaxed text-foreground-700">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-3 flex items-center gap-3 border-t border-background-200 pt-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-200 text-secondary-900">
                    <i className="ri-user-fill"></i>
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                  <span className="ml-auto flex items-center gap-0.5 text-accent-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs"></i>
                    ))}
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}